// Uploaded media is stored as a root-relative path ('/uploads/2026-07/ab12.webp')
// so the database stays portable across hosts and domains. The API and the client
// are separate origins in development, so the path has to be resolved against the
// API origin at render time rather than the page origin.
import { getApiBase, getMediaOrigin } from './apiBase';

const API_BASE = getApiBase();

// Strip the trailing '/api' to get the server root that serves /uploads.
export const MEDIA_ORIGIN = getMediaOrigin(API_BASE);

/** Absolute URL for a stored media path. Non-upload values pass through. */
export function mediaUrl(path: string): string {
  if (!path.startsWith('/uploads/')) return path;
  return `${MEDIA_ORIGIN}${path}`;
}
